// extracted by mini-css-extract-plugin
module.exports = {"content":"leave-proceed-modal_content__1AD8V","button-row":"leave-proceed-modal_button-row__2RUpJ","close-button":"leave-proceed-modal_close-button__HALBE"};